import React, {useState} from "react";
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Modal, ModalBody, Button} from "reactstrap";
import {PersonaDataCard} from './PersonaDataCard';
import { useSelector, useDispatch } from 'react-redux'
import { personasActions } from '../actions';
import { Spinner} from 'components/Icons/Spinner';
import {Badge} from 'components/Badges/Badge'
import { AddRelativeCard } from './AddRelativeCard';
import ReactBSAlert from 'react-bootstrap-sweetalert' ;


var Utils = require ('Utils');
var Const = require ('Const');
var Icons = require ('Icons');
const relation_types = ["Otros","Tutor","Padre","Madre","Abuelo","Abuela","Resp.Económico"] ;


const showField = ( label, content ) =>  {
  return (
      <div>
          <span className="text-muted">{label}: </span>{content}<br />
      </div>
     ) ;
}

export const  RelativesCard = ( { personaID, relatives, isMyProfile, removeRelated, addRelated } ) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [addRelative, setAddRelative] = useState(false);
  const [relative, setRelative] = useState(null);
  const [ alerta, setAlerta] = useState('');



  const { token, isLoading,isEditing } = useSelector(state => ({
    token: state.auth.session.jwt_token ,
    isLoading: state.view.loadingModules.getRelatives, 
    isEditing: state.view.loadingModules.editingRelativeDataCard
   }))

  const askRemoveRelative  = (token, nombre, persona_id, relative_id, isMyProfile)  => {
    setAlerta (
        <ReactBSAlert
              warning
              style={{ display: "block", marginTop: "-100px" }}
              title="Estás seguro?"
              onConfirm={() => {  removeRelated(token,persona_id, relative_id, isMyProfile) ;
                                  setAlerta(null);
                                }
                        }
              onCancel={() => setAlerta(null)}
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              confirmBtnText="Si, estoy seguro!"
              cancelBtnText="No"
              showCancel
              btnSize=""
            >
              Se va a eliminar a <b>{nombre}</b> como familiar del alumno.
        </ReactBSAlert>
      )
}

   // 
  const dispatch = useDispatch() ;

  const updateRelative = (token, personaID , data) => {
    dispatch(personasActions.updateRelative(token, personaID , data, isMyProfile ));
    setRelative( {...relative, ...data})
  }

    return (
        <>
        {alerta}
        <Modal toggle={() => setAddRelative(!addRelative)} isOpen={addRelative}  size="lg">
            <ModalBody >
                  <AddRelativeCard 
                    addRelated = {addRelated}
                    personaID = {personaID}
                    isMyProfile = {isMyProfile}
                    // enroleStudent={enroleStudent}
                    // unEnroleStudent={unEnroleStudent}
                    closeMe={setAddRelative}
                  />
            </ModalBody>
        </Modal>

        <Modal toggle={() => setModalOpen(!modalOpen)} isOpen={modalOpen}  size="lg">
            <ModalBody >
              <PersonaDataCard
                    isRelative={true} 
                    token= {token}
                    persona={relative}
                    updatePersona={updateRelative}  
                  />
                  <Row>
                    <Col className="ml-auto text-right" md="12">
                      <Button color="success" size="sm" disabled={isEditing}
                          onClick={() => setModalOpen(false)} 
                          >
                          {/* <span className="btn-label">
                          <i className="fa fa-pencil"></i>
                          </span> */}
                          Cerrar
                      </Button>
                    </Col>
                  </Row>

             </ModalBody>
        </Modal>

           <Card>
           <CardHeader>
             <CardTitle tag="h4">Contactos
                        {!isMyProfile && 
                          <div className="float-right">
                            <Link to="#"
                              onClick={() => { setAddRelative(!addRelative)  }}
                            >
                              <i className={Icons.PERSON_ADD} />
                            </Link>
                          </div>
                        }
                        </CardTitle>
           </CardHeader>
           <CardBody>
             <ul className="list-unstyled team-members">
                {/* <li><a href="#" onClick={() => setModalOpen(!modalOpen)} >Agregar contacto </a></li> */}
                {!isLoading?
                  relatives && relatives.map( persona => {
                    return (
                        <li>
                          <Row>
                            <Col md="2" xs="2">
                              <div className="avatar">
                                <img
                                  alt="..."
                                  className="img-circle img-no-padding img-responsive"
                                  src={persona.image?persona.image:Const.DEFAULT_IMAGE_PROFILE[(persona.gender?persona.gender:'O')]}
                                />
                              </div>
                            </Col>
                            <Col md="7" xs="7">
                              {persona.is_tutor ?
                              <>
                                {persona.first_tutor==="1"?
                                <b>{Utils.capitalize(persona.name + " " + persona.last_name) + " "}</b>
                                :
                                Utils.capitalize(persona.name + " " + persona.last_name) + " "
                                }
                                ({relation_types[persona.relation_type-1]})
                                  <br />
                                  <span className="text-muted">
                                    <small>
                                      {persona.doc_type}: {persona.doc_nbr} {persona.doc_nbr.length>8&& <Badge bgcolor='FF0000'>Validar DNI</Badge>}

                                      {persona.phone_home && showField("Casa",Utils.fmtPhone(persona.phone_home) )}
                                      {persona.phone_mobile &&  showField("Celular",Utils.fmtPhone(persona.phone_mobile) )}
                                      {persona.phone_emergency &&  showField("Emergencia",Utils.fmtPhone(persona.phone_emergency) )}
                                      {persona.phone_work &&  showField("Trabajo",Utils.fmtPhone(persona.phone_work) )}
                                      {persona.phone_extra &&  showField("Alternativo",Utils.fmtPhone(persona.phone_extra) )}
                                      {persona.email &&  showField("email",Utils.fmtPhone(persona.email) )}
                                    </small>
                                    <small>
                                      {persona.addr_street && showField("Calle",persona.addr_street)}
                                      {persona.addr_street_nbr && showField("Número",persona.addr_street_nbr)}
                                      {persona.addr_city && showField("Localidad",persona.addr_city)}
                                      {persona.addr_zip_code && showField("CP",persona.addr_zip_code)}
                                      {persona.addr_state && showField("Provincia",Const.getObjectByValue(Const.STATES, persona.addr_state).label)}
                                      {persona.addr_extra && showField("Indicaciones",persona.addr_extra)}
                                    </small>
                                  </span>
                              </>
                            :
                              <>
                                {Utils.capitalize(persona.name + " " + persona.last_name)} 
                                  <br />
                                  <span className="text-muted">
                                    {persona.course_name?
                                      <Link className="text-success" to={"/admin/course/" + persona.course_id}> {persona.course_name} </Link >
                                    :
                                      <small className="text-danger">
                                        Sin datos de relación
                                      </small>
                                    }
                                  </span>
                              </>
                            }
                          </Col>
                          <Col className="text-right" md="1" xs="1">
                              <Link
                                onClick={() => {setRelative( persona ) ;  setModalOpen(!modalOpen)  }}
                              >
                                <i className={Icons.EDIT} />
                              </Link>
                          </Col>
                          <Col className="text-right" md="1" xs="1">
                              <Link
                                onClick={() => {
                                  askRemoveRelative (token, Utils.capitalize(persona.name + " " + persona.last_name), 
                                        personaID, persona.persona_id, isMyProfile) }}
                              >
                                <i className={Icons.REMOVE} />
                              </Link>
                            </Col>
                          </Row>
                        </li>
                    )

                    })
                    :
                    <>
                    <Spinner /> Cargando contactos </>
                }
             </ul>
           </CardBody>
         </Card>
        </>
    );
  }


